import m from "@utils/strings";
import _ from "lodash";

export default class ParametrosSolicitacaoProcedimentos {
  requisicaoAutorizacaoDTO: any;
  profissionalExecutanteDTO: any;
  listaProcedimentos: any;
  indicacaoClinica: string;
  indicacaoClinicaNormal: string;
  atendimento: string = "";
  observacao: string;
  constructor(
    autorizacao: any,
    profissionalExecutante: any,
    procedimentos: any,
    observacao: string | null,
  ) {
    let requisicaoAutorizacaoDTO;
    let profissionalExecutanteDTO;
    let listaProcedimentos;

    try {
      requisicaoAutorizacaoDTO = {
        ...autorizacao,
      };

      if (_.isEmpty(requisicaoAutorizacaoDTO)) throw "vazio";
    } catch (e) {
      throw new DOMException(
        m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_DADOS_BENEFICIARIO
      );
    }
    try {
      if (!profissionalExecutante.Nome) throw "Profissional Solicitante";
      if (!profissionalExecutante.Conselho) throw "Conselho";
      if (!profissionalExecutante.Estado) throw "Estado";
      if (!profissionalExecutante.Numeroconselho) throw "Número Conselho";
      if (!profissionalExecutante.ocupacao.id) throw "Ocupação";
      if (!profissionalExecutante.ocupacao.descricao) throw "Ocupação";

      profissionalExecutanteDTO = {
        profissionalExecutante: {
          id: profissionalExecutante.Id,
          nome: profissionalExecutante.Nome,
          conselho: profissionalExecutante.Conselho,
          estado: profissionalExecutante.Estado,
          numeroconselho: profissionalExecutante.Numeroconselho,
          idprestador: profissionalExecutante.Idprestador,
        },
        ocupacoes: [
          {
            id: profissionalExecutante.ocupacao.id,
            descricao: profissionalExecutante.ocupacao.descricao,
          },
        ],
      };
    } catch (e) {
      throw new DOMException(
        m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_DADOS_SOLICITACAO
      );
    }
    try {
      listaProcedimentos = [];
      listaProcedimentos = procedimentos.procedimentos.map(
        (procedimento: any) => {
          const p = {
            codigo: procedimento.Codigo,
            codigoTabela: procedimento.Tabela,
            descricao: procedimento.Descricao,
            quantidadeSolicitada: procedimento.quantidade,
            requerAuditoria: procedimento.RequerAuditoria
              ? procedimento.RequerAuditoria
              : false,
          };
          return p;
        }
      );

      if (_.isEmpty(listaProcedimentos)) throw "Lista de Procedimentos";
    } catch (e) {
      throw new DOMException(
        m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_DADOS_PROCEDIMENTOS
      );
    }
    this.requisicaoAutorizacaoDTO = requisicaoAutorizacaoDTO;
    this.profissionalExecutanteDTO = profissionalExecutanteDTO;
    this.listaProcedimentos = listaProcedimentos;
    this.indicacaoClinica = procedimentos.indicacaoClinica;
    this.indicacaoClinicaNormal = procedimentos.indicacaoClinicaNormal;
    this.observacao = observacao?.length ? observacao : "";
  }
}
